
import Vue from "vue"
import { VueConstructor } from "vue/types/umd"
import { EventBus } from "@/plugins/eventBus"
import axios from "axios"

export default (Vue as VueConstructor<Vue>).extend({
  name: "UpdateStateDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectedSW: {
      type: Array as () => string[],
      required: true
    }
  },
  data: () => ({
    loading: false,
    selectedState: null as string | null,
    states: [] as Array<{value: string, name: string}>
  }),
  computed: {
    inputValue: {
      get(): boolean {
        return this.value
      },
      set(val: boolean) {
        this.$emit('input', val)
      }
    },
    selectedWorkersText(): string {
      const count = this.selectedSW.length;
      return count + ' ' + this.$vuetify.lang.t(`$vuetify.${count > 1 ? 'workers' : 'worker'}`);
    }
  },
  created() {
    this.initializeStates();
  },
  methods: {
    checkSelection() {
      // Display snackbar error and hide component if no super_worker in selection
      if (this.selectedSW.length === 0) {
        EventBus.$emit('snackbar', { message: this.$vuetify.lang.t('$vuetify.empty_selection'), color: 'error' })
        this.inputValue = false
        return false
      }
      return true
    },
    initializeStates() {
      this.states = [
        {value: "web", name: this.$vuetify.lang.t('$vuetify.worker_states.web')},
        {value: "candidate", name: this.$vuetify.lang.t('$vuetify.worker_states.candidate')},
        {value: "employee", name: this.$vuetify.lang.t('$vuetify.worker_states.employee')},
        {value: "applicant", name: this.$vuetify.lang.t('$vuetify.worker_states.applicant')},
        {value: "pre-registered", name: this.$vuetify.lang.t('$vuetify.worker_states.pre_registered')},
        {value: "supplements OK", name: this.$vuetify.lang.t('$vuetify.worker_states.supplement_ok')}
      ];
    },
    async submit() {
      this.loading = true;
      
      try {
        const requestData: {[key: string]: any} = {};
        
        // Create request body with state updates for all selected workers
        this.selectedSW.forEach((workerId: string) => {
          requestData[workerId] = { state: this.selectedState };
        });
        
        // Make API request
        await axios.put('/v1/workers', requestData);
        
        // Show success message
        EventBus.$emit('snackbar', {
          message: this.$vuetify.lang.t('$vuetify.state_modified'),
          color: 'success'
        });
        
        // Close dialog
        this.inputValue = false;
        
        // Emit completed event so parent can refresh data if needed
        this.$emit('completed');
      } catch (error) {
        EventBus.$emit('snackbar', { axiosError: error });
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    inputValue(val: boolean) {
      if (val === true) {
        // Check if selection is empty when dialog opens
        if (!this.checkSelection()) return;
        
        // Reset the selected state when dialog opens
        this.selectedState = null;
      }
    }
  }
})
